import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "./components/app/asyncComponent";
import PublicRoute from "./components/app/publicRoute";
import ProtectedRoute from "./components/app/protectedRoute";

// import UnauthenticatedRoute from './components/UnauthenticatedRoute';

export const PATH_HOME = "/";
export const PATH_LOGIN = "/login";
export const PATH_LOGIN_WORKSPACE = "/login/:workspaceSlug";
export const PATH_LOGOUT = "/logout";
export const PATH_USERS = "/users";
export const PATH_USERS_LIST_PAGE = "/users/page/:page";
export const PATH_MONITORING = "/folders/monitoring";
export const PATH_RESEARCH = "/folders/research";
export const PATH_FOLDERS = "/folders/:type";
export const PATH_FOLDERS_LIST_PAGE = "/folders/:type/page/:page";
export const PATH_FOLDER = "/folders/:type/:folderId/:view";
export const PATH_FOLDER_LIST = "/folders/:type/:folderId/list";
export const PATH_FOLDER_LIST_PAGE = "/folders/:type/:folderId/list/:page";
export const PATH_FOLDER_DETAILS =
  "/folders/:type/:folderId/details/:collectionId";
export const PATH_FOLDER_DETAILS_DOCUMENT =
  "/folders/:type/:folderId/details/:collectionId/:documentId";
export const PATH_FOLDER_DETAILS_DOCUMENT_FOCUS =
  "/folders/:type/:folderId/details/:collectionId/:documentId/focus";
export const PATH_FOLDER_DETAILS_DOCUMENT_MODE =
  "/folders/:type/:folderId/details/:collectionId/:documentId/:mode";
export const PATH_ORGANIZATIONS = "/organizations";
export const PATH_ORGANIZATIONS_LIST_PAGE = "/organizations/page/:page";
export const PATH_IMPORT = "/import";
export const PATH_IMPORTS = "/imports";
export const PATH_IMPORT_DETAILS = "/imports/:importId";
export const PATH_ACCOUNT = "/account";

export const getLink = (ROUTE, params = {}) => {
  let url = ROUTE;
  Object.keys(params).forEach((key) => {
    url = url.replace(":" + key, params[key]);
  });
  return url;
};

const AsyncHome = asyncComponent(() => import("./pages/home"));
const AsyncLogin = asyncComponent(() => import("./pages/login"));
const AsyncLogout = asyncComponent(() => import("./pages/logout"));
const AsyncUsers = asyncComponent(() => import("./pages/users"));
const AsyncNotFound = asyncComponent(() => import("./pages/notFound"));
const AsyncFolders = asyncComponent(() => import("./pages/folders"));
const AsyncFolder = asyncComponent(() => import("./pages/folder"));
const AsyncFolderDetails = asyncComponent(() =>
  import("./pages/folderDetails")
);
const AsyncOrganizations = asyncComponent(() =>
  import("./pages/organizations")
);
const AsyncAccount = asyncComponent(() => import("./pages/account"));
const AsyncImport = asyncComponent(() => import("./pages/import"));
const AsyncImports = asyncComponent(() => import("./pages/imports"));
const AsyncImportDetails = asyncComponent(() =>
  import("./pages/importDetails")
);

export default ({ store }) => {
  const { auth } = store.getState() || null;
  const props = { user: auth.user };
  console.log("render routes", props);
  return (
    <Switch>
      <ProtectedRoute
        path={PATH_HOME}
        exact
        component={AsyncHome}
        props={props}
      />
      <PublicRoute
        path={PATH_LOGIN}
        exact
        component={AsyncLogin}
        props={props}
      />

      <PublicRoute
        path={PATH_LOGIN_WORKSPACE}
        exact
        component={AsyncLogin}
        props={props}
      />

      <ProtectedRoute
        path={PATH_LOGOUT}
        exact
        component={AsyncLogout}
        props={props}
      />
      <ProtectedRoute
        path={PATH_USERS}
        exact
        component={AsyncUsers}
        props={props}
      />

      <ProtectedRoute
        path={PATH_USERS_LIST_PAGE}
        exact
        component={AsyncUsers}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDERS}
        exact
        component={AsyncFolders}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDERS_LIST_PAGE}
        exact
        component={AsyncFolders}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDER}
        exact
        component={AsyncFolder}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDER_LIST_PAGE}
        exact
        component={AsyncFolder}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDER_DETAILS}
        exact
        component={AsyncFolderDetails}
        props={props}
      />

      <ProtectedRoute
        path={PATH_FOLDER_DETAILS_DOCUMENT}
        exact
        component={AsyncFolderDetails}
        props={props}
      />
      <ProtectedRoute
        path={PATH_FOLDER_DETAILS_DOCUMENT_MODE}
        exact
        component={AsyncFolderDetails}
        props={props}
      />

      <ProtectedRoute
        path={PATH_IMPORT}
        exact
        component={AsyncImport}
        props={props}
      />

      <ProtectedRoute
        path={PATH_IMPORTS}
        exact
        component={AsyncImports}
        props={props}
      />

      <ProtectedRoute
        path={PATH_IMPORT_DETAILS}
        exact
        component={AsyncImportDetails}
        props={props}
      />

      <ProtectedRoute
        path={PATH_ORGANIZATIONS}
        exact
        component={AsyncOrganizations}
        props={props}
      />

      <ProtectedRoute
        path={PATH_ORGANIZATIONS_LIST_PAGE}
        exact
        component={AsyncOrganizations}
        props={props}
      />

      <ProtectedRoute
        path={PATH_ACCOUNT}
        exact
        component={AsyncAccount}
        props={props}
      />

      {/* <ProtectedRoute
        path='/users/:id'
        exact
        component={AsyncUsers}
        props={childProps}
      /> */}
      {/* Finally, catch all unmatched routes */}
      <Route component={AsyncNotFound} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js